import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import Spinner from 'britive-design-system/core/components/spinner'
import ApprovalsView from './ApprovalsView'
import { classes, translatedStrings, statusLabel } from './constants'
import { getSecretStatus, getActionLabel } from '../../utils'
import toast from 'utils/toast'
import { getTicketDetails } from 'action_creators/access'
import TicketDetails from './ticket-details'
import {
  getApprovalsDetailsById,
  getLabelDetails,
  detailsApproveRequest,
  detailsRejectRequest,
} from '../../../../action_creators/my-approvals'
import './myApprovalsDetails.scss'

const MyApprovalsDetails = ({ history, approvalId, redirectPath }) => {
  const [ticketDetails, setTicketDetails] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const approvalsDetails = useSelector(
    state => state.userSecretsReducer?.myApprovalsDetails
  )
  const approvalsResourceLabels = useSelector(
    state => state.userSecretsReducer?.myApprovalsLabelDetails
  )

  const dispatch = useDispatch()

  const fetchTicketDetails = async () => {
    try {
      setIsLoading(true)
      const { value } = await dispatch(
        getTicketDetails(
          approvalsDetails?.data?.context?.connectionId,
          approvalsDetails?.data?.context?.ticketType,
          approvalsDetails?.data?.context?.ticketId
        )
      )
      setTicketDetails(value.data)
    } catch {
      toast({
        title: 'Failed to fetch the ticket details.',
        type: 'error',
        time: 'normal',
      })
    } finally {
      setIsLoading(false)
    }
  }

  const closeTicketDetailsModal = () => {
    setTicketDetails({})
  }

  return (
    <div>
      {approvalsDetails?.loading || approvalsResourceLabels?.loading || isLoading ? (
        <Spinner
          size={'medium'}
          message={translatedStrings.loading}
          overlay={true}
        />
      ) : null}
      <ApprovalsView
        id={approvalId}
        history={history}
        approvalsDetails={approvalsDetails}
        approvalsResourceLabels={approvalsResourceLabels}
        getSecretStatus={getSecretStatus}
        getActionLabel={getActionLabel}
        translatedStrings={translatedStrings}
        getApprovalsDetailsById={getApprovalsDetailsById}
        getLabelDetails={getLabelDetails}
        approveRequest={detailsApproveRequest}
        rejectRequest={detailsRejectRequest}
        classes={classes}
        statusLabel={statusLabel}
        redirectPath={redirectPath}
        ticketDetails={ticketDetails}
        fetchTicketDetails={fetchTicketDetails}
      />
      {!isEmpty(ticketDetails) && !isLoading && (
        <TicketDetails
          onClose={closeTicketDetailsModal}
          translatedStrings={translatedStrings}
          approvalsDetails={approvalsDetails}
          ticketDetails={ticketDetails}
        />
      )}
    </div>
  )
}

export default MyApprovalsDetails
